/**
 * Party-identity minting helper (P18).
 *
 * Centralizes `partyId` creation so chargen, the reuse-party fork path,
 * and any future save migration all produce ids the same way.
 * Prefers `crypto.randomUUID`, but falls back to `getRandomValues` —
 * `randomUUID` requires a secure context, and dev builds served from
 * `http://<lan-host>:5173` (not `localhost`) don't qualify on Safari.
 * `getRandomValues` is available in insecure contexts, so the fallback
 * still routes through the platform CSPRNG (no `Math.random()`).
 */

export function mintUuid(): string {
  if (typeof globalThis.crypto?.randomUUID === "function") {
    return globalThis.crypto.randomUUID();
  }
  const bytes = new Uint8Array(16);
  globalThis.crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6]! & 0x0f) | 0x40;
  bytes[8] = (bytes[8]! & 0x3f) | 0x80;
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

export function mintPartyId(): string {
  return mintUuid();
}
